var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8,37.7h-3c-2.8,0-5.1-2.3-5.1-5.1V7.4c0-2.8,2.3-5.1,5.1-5.1H16c0.6,0,1.1-0.5,1.1-1.1S16.6,0,16,0h-3.2 C8.7,0,5.4,3.3,5.4,7.4v25.1c0,4.1,3.3,7.4,7.4,7.4h3c0.6,0,1.1-0.5,1.1-1.1S16.5,37.7,15.8,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,19.2L27,11.9c-0.4-0.4-1.2-0.4-1.6,0c-0.4,0.4-0.4,1.2,0,1.6l5.3,5.3H18.3c-0.6,0-1.1,0.5-1.1,1.1 s0.5,1.1,1.1,1.1h12.4l-5.3,5.3c-0.4,0.4-0.4,1.2,0,1.6c0.2,0.2,0.5,0.3,0.8,0.3s0.6-0.1,0.8-0.3l7.3-7.3 C34.8,20.4,34.8,19.6,34.3,19.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.21850bb6.svg";
export { ForwardRef as ReactComponent };